module.exports = __webpack_public_path__ + "img/illusion-bg.6a51347.png";